import type { ReactNode } from "react";

/** Compact rose-tinted error block used wherever a query/action fails. */
export function ErrorBanner({ children }: { children: ReactNode }) {
	return (
		<p className="rounded-md border border-rose-900/60 bg-rose-950/40 p-2 text-[11px] text-rose-300">
			{children}
		</p>
	);
}
